// src/OverseasConsulting.js (New Component - Create this file in src/)
import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Consulting = ({ onBack }) => {
   useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return (
    <div className="bg-white min-h-screen text-black font-sans">
      {/* Navigation with Back Button */}
      <nav className="sticky top-0 z-50 bg-white shadow-md px-6 py-4 border-b border-gray-200">
        <div className="container mx-auto flex justify-between items-center">
          <motion.button
            onClick={onBack}
            className="flex items-center text-red-500 hover:text-red-600 text-lg font-semibold transition-colors"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            ← Back to Home
          </motion.button>
          <h1 className="text-2xl font-bold">
            <span className="text-red-500">Brain</span>Serve
          </h1>
        </div>
      </nav>

      {/* Hero Section for Consulting */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <motion.h1 
            className="text-5xl md:text-6xl font-bold mb-6"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Overseas 
            <span className="text-red-500 block">Consulting</span>
          </motion.h1>
          <motion.p 
            className="text-xl text-gray-600 max-w-3xl mx-auto mb-8"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Your gateway to global success. Brain Serve provides end-to-end consulting for overseas opportunities, 
            from visa processing to seamless relocation, ensuring a smooth transition to your international dreams.
          </motion.p>
          <button className="bg-red-500 hover:bg-red-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-red-500/50">
            Start Your Journey
          </button>
        </div>
      </section>

      {/* Consulting Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <motion.h2 
            className="text-4xl font-bold text-center mb-16 text-black"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            Our Consulting Services
          </motion.h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Visa Assistance */}
            <motion.div
              className="bg-gray-50 rounded-2xl p-6 border border-gray-200 hover:border-red-500 transition-all duration-300 shadow-sm hover:shadow-md"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              whileHover={{ y: -5 }}
            >
              <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-white">📄</span>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-center">Visa Assistance</h3>
              <p className="text-gray-600 mb-4 text-center">Expert guidance for work, study, and tourist visas to USA, Canada, UK, Australia, and more. Success rate over 95%.</p>
              <ul className="text-sm text-gray-500 space-y-1 mb-6">
                <li>• Comprehensive document preparation</li>
                <li>• Interview coaching and mock sessions</li>
                <li>• Post-approval support</li>
              </ul>
              <button className="w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded-xl transition duration-300">
                Book Consultation
              </button>
            </motion.div>

            {/* Relocation Services */}
            <motion.div
              className="bg-gray-50 rounded-2xl p-6 border border-gray-200 hover:border-red-500 transition-all duration-300 shadow-sm hover:shadow-md"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              whileHover={{ y: -5 }}
            >
              <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-white">🧳</span>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-center">Relocation Support</h3>
              <p className="text-gray-600 mb-4 text-center">Hassle-free moves with housing, schooling, and local integration plans tailored to your family's needs.</p>
              <ul className="text-sm text-gray-500 space-y-1 mb-6">
                <li>• Customized relocation packages</li>
                <li>• Partner networks for logistics</li>
                <li>• Cultural orientation programs</li>
              </ul>
              <button className="w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded-xl transition duration-300">
                Book Consultation
              </button>
            </motion.div>

            {/* Career Counseling */}
            <motion.div
              className="bg-gray-50 rounded-2xl p-6 border border-gray-200 hover:border-red-500 transition-all duration-300 shadow-sm hover:shadow-md"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              whileHover={{ y: -5 }}
            >
              <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-white">💼</span>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-center">Career Counseling</h3>
              <p className="text-gray-600 mb-4 text-center">Personalized advice on job markets, resume building, and interview prep for international careers.</p>
              <ul className="text-sm text-gray-500 space-y-1 mb-6">
                <li>• Skill gap analysis and upskilling</li>
                <li>• Job placement assistance</li>
                <li>• Salary negotiation tips</li>
              </ul>
              <button className="w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded-xl transition duration-300">
                Book Consultation
              </button>
            </motion.div>

            {/* Immigration Planning */}
            <motion.div
              className="bg-gray-50 rounded-2xl p-6 border border-gray-200 hover:border-red-500 transition-all duration-300 shadow-sm hover:shadow-md"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              whileHover={{ y: -5 }}
            >
              <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-white">🌐</span>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-center">Immigration Planning</h3>
              <p className="text-gray-600 mb-4 text-center">Long-term strategies for PR, citizenship, and family reunification across major destinations.</p>
              <ul className="text-sm text-gray-500 space-y-1 mb-6">
                <li>• Pathway evaluations and timelines</li>
                <li>• Legal compliance checks</li>
                <li>• Ongoing advisory support</li>
              </ul>
              <button className="w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded-xl transition duration-300">
                Book Consultation
              </button>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Why Choose Us for Consulting */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <motion.h2 
            className="text-4xl font-bold mb-8 text-black"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            Why Brain Serve for Overseas Consulting?
          </motion.h2>
          <motion.div 
            className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-2 text-red-500">Global Expertise</h3>
              <p className="text-gray-600">Team of certified consultants with 10+ years in international migration and career services.</p>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-2 text-red-500">Tailored Solutions</h3>
              <p className="text-gray-600">Custom plans based on your profile, budget, and goals for maximum success.</p>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-2 text-red-500">End-to-End Support</h3>
              <p className="text-gray-600">From initial assessment to post-arrival, we're with you every step.</p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white py-8 text-center text-gray-500 border-t border-gray-200">
        <p>&copy; 2025 Brain Serve. All rights reserved. | Go Global with Confidence.</p>
      </footer>
    </div>
  );
};

export default Consulting;